var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-headful',{attrs:{"title":`Write for me!`,"description":`Report list`}}),_c('p',{staticClass:"display-1"},[_vm._v(" Reports ")]),_c('reportList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }